import { motion } from "framer-motion";

// Reusable scroll-reveal wrapper
export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

// Section label (numbered manifesto chapter marker)
export const SectionLabel = ({ number, title }) => (
  <div className="flex items-center gap-4 mb-6" data-testid={`label-${number}`}>
    <span className="font-display text-[#d4af37] text-sm font-semibold tracking-[0.3em]">
      {number}
    </span>
    <span className="h-px w-10 bg-[#d4af37]/40" />
    <span className="text-[#cccccc] text-xs tracking-[0.3em] uppercase">
      {title}
    </span>
  </div>
);

export const smoothScrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};
